import { inject, InjectionToken } from '@angular/core'

import { JsonLd } from '../json-ld.service'
import { JsonLdLoaderService } from './json-ld-loader.service'

export const JSON_LD_ORGANIZATION = new InjectionToken<JsonLd>(ngDevMode ? 'JSON_LD_ORGANIZATION' : '', {
  providedIn: 'root',
  factory: () => inject(JsonLdLoaderService).organization,
})
